(function () {
  function swiperInit() {
    subSliderInit(true);
    sliderInit(true);
    popupSliderInit(true);
  }

  document.addEventListener("shopify:section:load", function (e) {
    swiperInit();
  });

  swiperInit();

  // FIX responsive: Swiper thumbnail đặt direction (dọc desktop / ngang mobile) MỘT lần lúc init.
  // Khi khách co giãn / xoay ngang qua mốc 990px, CSS đổi nhưng Swiper không → thumbnail dọc
  // thành cột cao trên mobile (vỡ layout). Dùng changeDirection() (không destroy, giữ nguyên
  // sync + variant filter) khi vượt breakpoint; luôn update() để đo lại kích thước.
  var _lastIsMobile = window.innerWidth < 990;
  var _resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(_resizeTimer);
    _resizeTimer = setTimeout(function () {
      var isMobile = window.innerWidth < 990;
      var crossed = isMobile !== _lastIsMobile;
      _lastIsMobile = isMobile;
      document.querySelectorAll(".js-media-sublist").forEach(function (el) {
        if (!el.swiper) return;
        if (crossed) {
          el.swiper.changeDirection(isMobile ? "horizontal" : "vertical");
          el.swiper.params.spaceBetween = isMobile ? 8 : 16;
        }
        el.swiper.update();
      });
      document.querySelectorAll(".js-media-list").forEach(function (el) {
        if (el.swiper) el.swiper.update();
      });
    }, 200);
  });
})();
